<div class="wrp" [style.margin]="mediaService.deskmode() ? '20px' : '0px'"
    [style.padding]="mediaService.deskmode() ? '20px' : '0px 20px'">
    @for (sn of column().menus; track $index) {
    @if(sn.isItem) {
    @if(sn.image?.length > 0) {
    <div class="menuItem">
        <a [href]="sn?.link" class="w100 item hlink">
            <div class="menuimgwrp">
                <div class="menuimgbody">
                    <img class="imgmenu" [src]="sn.image" alt="img">
                </div>
                <div class="menuinputwrp">
                    <span class="menuinputwrpspan">{{sn.title}}</span>
                    <p class="menuinputwrpp">{{sn.subtitle}}</p>
                </div>
            </div>
        </a>
    </div>
    } @else {
    <div class="menuItem">
        <a [href]="sn?.link" class="w100 item hlink">{{sn.title}}</a>
    </div>
    }

    } @else {
    <div class="repwrp">
        <div class="rephwrp">
            <a [href]="sn?.link" class="rep hlink">{{sn?.title}}</a>
        </div>
        <div class="rephwrpsub">
            @for (subsn of sn.menus; track $index) {
            @if(subsn.image?.length > 0) {
            <div class="menuItem">
                <a [href]="subsn?.link" class="w100 item hlink">
                    <div class="menuimgwrp">
                        <div class="menuimgbody">
                            <img class="imgmenu" [src]="subsn.image" alt="img">
                        </div>
                        <div class="menuinputwrp">
                            <span class="menuinputwrpspan">{{subsn.title}}</span>
                            <p class="menuinputwrpp">{{subsn.subtitle}}</p>
                        </div>
                    </div>
                </a>
            </div>
            } @else {
            <div class="menuItem">
                <a [href]="subsn?.link" class="w100 item hlink">{{subsn.title}}</a>
            </div>
            }
            }
        </div>
    </div>
    <div class="spacer"></div>
    }
    }
</div>